<template>
  <div>
    <b-modal
      id="uchicago-upcoming-deliveries-modal"
      ref="modal"
      size="lg"
      hide-header
      hide-footer
    >
      <div class="py-3">
        <h4 class="text-center">
          Upcoming Deliveries
        </h4>

        <div class="p-4 mb-3 border-dark border-opacity-25 rounded-3 bg-light">
          <p>
            We hope you had a wonderful summer and are looking forward to helping you get the new school year started with ease.
          </p>

          <h5>On-Campus Students</h5>

          <p>
            We are busy preparing your delivery and will have your things waiting for you in your upcoming room assignment prior to your arrival to campus! We are working with university housing to get your new room assignment so you do not need to update your address with us. On-campus deliveries are scheduled for September 11th - 15th.
          </p>

          <h5>Approved Early Returns (RAs & Selected OAs)</h5>

          <p>All students with a university-approved early arrival will have their things delivered prior to their arrival.</p>

          <h5>Off-Campus Returns</h5>

          <p>
            Please reach out to schedule your delivery to your off-campus housing if you have not done so. The week of September 11th - 15th is CLOSED to off-campus deliveries. Please be aware that all deliveries are scheduled on a first-come-first-served basis.
          </p>

        </div>

        <div class="text-center">
          <button
            class="btn btn-primary"
            @click="handleContinueClicked"
          >
            Continue
          </button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

import { BModal } from "bootstrap-vue";

@Component({
})
export default class UpcomingDeliveriesModal extends Vue {

  @Prop({
    default: false
  })
  showOnce!: boolean;

  $refs!: {
    modal: BModal | any
  }

  mounted() {
    if (this.showOnce) {
      let modalState = localStorage.getItem("UpcomingDeliveriesModal.state");

      if (!modalState)
        this.activate();
    }
    else{
      this.activate();
    }
  }

  activate() {
    this.$bvModal.show('uchicago-upcoming-deliveries-modal');
  }

  handleContinueClicked() {
    if (this.showOnce)
      localStorage.setItem("UpcomingDeliveriesModal.state", "1");

    this.$refs.modal.hide();
  }
}
</script>

<style lang="scss" scoped>
.rounded-3 {
  border-radius: 0.75rem;
}
</style>
